const NavYouTubeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2733 17.3459L14.6025 20.5736C14.3662 20.7018 14.1129 20.7651 13.8628 20.7651C13.5956 20.7651 13.3315 20.6925 13.0937 20.5505C12.6365 20.2786 12.3631 19.8014 12.3631 19.2702V12.8133C12.3631 12.2728 12.6442 11.7848 13.1138 11.5146C13.5801 11.2443 14.1361 11.2412 14.6056 11.5115L20.2733 14.7391C20.7397 15.0016 21.0301 15.5035 21.0301 16.041C21.0301 16.5815 20.7397 17.0803 20.2733 17.3459ZM29.9996 8.10775C29.5996 6.4553 28.3518 5.13335 26.7441 4.64997C24.0153 3.74962 7.76718 3.80058 5.2777 4.70402C3.66387 5.16423 2.40832 6.49237 2.02069 8.10157C1.10644 10.7748 1.10644 21.3427 2.00679 23.9866C2.45465 25.6005 3.70865 26.8776 5.22674 27.2992C6.5626 27.7842 11.3331 28.0235 16.0758 28.0235C20.7876 28.0235 25.4747 27.7872 26.7318 27.3147C28.3456 26.8359 29.5981 25.5093 29.9795 23.9248C30.8907 21.3025 30.8938 10.7625 29.9996 8.10775Z"
        fill="url(#paint0_linear_15183_166099)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15183_166099"
          x1="15.9999"
          y1="4"
          x2="15.9999"
          y2="28.0235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#89B8F0" />
          <stop offset="1" stopColor="#165BAD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NavYouTubeIcon
